/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { WeatherStationData } from '../../models/weather-station-data';

export interface GetWeathers$Params {
   /**
    * Start date in format YYYY-MM-DD (inclusive).
    */
   startDate?: string;

   /**
    * End date in format YYYY-MM-DD (exclusive).
    */
   endDate?: string;

   /**
    * Provider id (IBM,EPA5,etc)
    */
   providerId?: string;

   /**
    * Latitude
    */
   lat?: number;

   /**
    * Longitude
    */
   lon?: number;

   /**
    * Weather calculation mode (avg, near)
    */
   mode?: string;

   /**
    * Retrieve extended weather data
    */
   extended?: boolean;

   /**
    * Retrieve daily norms
    */
   dailyNorms?: boolean;

   /**
    * Retrieve monthly norms
    */
   monthlyNorms?: boolean;

   /**
    * Retrieve by year statistic
    */
   yearlyStats?: boolean;

   /**
    * Retrieve daily statistic
    */
   dailyStats?: boolean;
}

export function getWeathers(
   http: HttpClient,
   rootUrl: string,
   params?: GetWeathers$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<WeatherStationData>>> {
   const rb = new RequestBuilder(rootUrl, getWeathers.PATH, 'get');
   if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('endDate', params.endDate, {});
      rb.query('providerId', params.providerId, {});
      rb.query('lat', params.lat, {});
      rb.query('lon', params.lon, {});
      rb.query('mode', params.mode, {});
      rb.query('extended', params.extended, {});
      rb.query('dailyNorms', params.dailyNorms, {});
      rb.query('monthlyNorms', params.monthlyNorms, {});
      rb.query('yearlyStats', params.yearlyStats, {});
      rb.query('dailyStats', params.dailyStats, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<WeatherStationData>>;
      })
   );
}

getWeathers.PATH = '/api/weather/weather';
